const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410307001',
            ext_path: '河南省 洛阳市 偃师区 城关镇',
            cid: '1',
            pid: '410307',
            name: '城关镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.754304, 34.736165]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410307110',
            ext_path: '河南省 洛阳市 偃师区 大口镇',
            cid: '2',
            pid: '410307',
            name: '大口镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.722683, 34.544174]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410307107',
            ext_path: '河南省 洛阳市 偃师区 府店镇',
            cid: '3',
            pid: '410307',
            name: '府店镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.861056, 34.522728]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410307108',
            ext_path: '河南省 洛阳市 偃师区 高龙镇',
            cid: '4',
            pid: '410307',
            name: '高龙镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.709389, 34.624589]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410307106',
            ext_path: '河南省 洛阳市 偃师区 缑氏镇',
            cid: '5',
            pid: '410307',
            name: '缑氏镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.792366, 34.592554]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410307105',
            ext_path: '河南省 洛阳市 偃师区 顾县镇',
            cid: '6',
            pid: '410307',
            name: '顾县镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.783381, 34.658811]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410307111',
            ext_path: '河南省 洛阳市 偃师区 邙岭镇',
            cid: '7',
            pid: '410307',
            name: '邙岭镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.739453, 34.774757]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410307109',
            ext_path: '河南省 洛阳市 偃师区 山化镇',
            cid: '8',
            pid: '410307',
            name: '山化镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.870775, 34.739003]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410307005',
            ext_path: '河南省 洛阳市 偃师区 商城街道',
            cid: '9',
            pid: '410307',
            name: '商城街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.800426, 34.716647]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410307004',
            ext_path: '河南省 洛阳市 偃师区 首阳山街道',
            cid: '10',
            pid: '410307',
            name: '首阳山街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.68546, 34.731741]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410307104',
            ext_path: '河南省 洛阳市 偃师区 岳滩镇',
            cid: '11',
            pid: '410307',
            name: '岳滩镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.746002, 34.691629]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410307103',
            ext_path: '河南省 洛阳市 偃师区 翟镇镇',
            cid: '12',
            pid: '410307',
            name: '翟镇镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.682545, 34.679196]
        }
    }
];

export { d };
